import { SafeHtml } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

export class EventCategory {
  static seminary = 0;
  static course = 1;
  static presentation = 2;

  static reverseNames = [
    'Seminario',
    'Corso',
    'Presentazione'
  ];
}

export class ManifestationCategory {
  static cultural = 0;
  static sporty = 1;
  static artistic = 2;

  static matches: { [key: number]: string; } = {
    0: 'Culturale',
    1: 'Sportivo',
    2: 'Artistico'
  };

  static values = [
    { code: 0, typeName: ManifestationCategory.matches[0] },
    { code: 1, typeName: ManifestationCategory.matches[1] },
    { code: 2, typeName: ManifestationCategory.matches[2] }
  ];
}

export interface Manifestation {
  _htmlPhotoUrl?: string;
  _startDate?: Date;
  _startDateHour?: Date;
  _endDate?: Date;
  _endDateHour?: Date;
  _viasStartDateHour?: string;
  _viasEndDateHour?: string;
  _reverseCategory?: string;

  id?: number;
  name?: string;
  locationDescription?: string;
  dateStart?: Date;
  dateEnd?: Date;
  description?: string;
  program?: string;
  activityLink?: string;
  category?: number;
  contactReference?: string;
  photoUrl?: string;

  locationLat?: number;
  locationLng?: number;
}

export class Category {
  static photos = [
    `${environment.baseUrl}/assets/category/art1.png`,
    `${environment.baseUrl}/assets/category/art2.png`,
    `${environment.baseUrl}/assets/category/art3.png`,
    `${environment.baseUrl}/assets/category/art4.png`,
    `${environment.baseUrl}/assets/category/art5.png`,
    `${environment.baseUrl}/assets/category/course1.png`,
    `${environment.baseUrl}/assets/category/course2.png`,
    `${environment.baseUrl}/assets/category/course3.png`,
    `${environment.baseUrl}/assets/category/course4.png`,
    `${environment.baseUrl}/assets/category/culture1.png`,
    `${environment.baseUrl}/assets/category/culture2.png`,
    `${environment.baseUrl}/assets/category/culture3.png`,
    `${environment.baseUrl}/assets/category/culture4.png`,
    `${environment.baseUrl}/assets/category/culture5.png`,
    `${environment.baseUrl}/assets/category/presentation1.png`,
    `${environment.baseUrl}/assets/category/presentation2.png`,
    `${environment.baseUrl}/assets/category/presentation3.png`,
    `${environment.baseUrl}/assets/category/seminary1.png`,
    `${environment.baseUrl}/assets/category/seminary2.png`,
    `${environment.baseUrl}/assets/category/sport1.png`,
    `${environment.baseUrl}/assets/category/sport2.png`,
    `${environment.baseUrl}/assets/category/sport3.png`,
    `${environment.baseUrl}/assets/category/sport4.png`,
    `${environment.baseUrl}/assets/category/sport5.png`,
  ];
}

export interface LoginRequest {
  username?: string;
  password?: string;
  token?: string;
}

export interface ConfirmRequest {
  userId?: string;
  token?: string;
}

export interface ForgotRequest {
  email?: string;
}

export interface SendConfirmRequest {
  email?: string;
}

export interface ResetRequest {
  userId?: string;
  password?: string;
  confirmPassword?: string;
  token?: string;
}

export interface RegisterRequest {
  email?: string;
  password?: string;
  confirmPassword?: string;
}

export interface StartEndRequest {
  startDate?: Date;
  endDate?: Date;
  destinationId?: number;
  consumerIds?: number[];
}

export class MapPoint {
  name: string;
  latitude: number;
  longitude: number;
}

export class NominatimResponse {
  constructor(
    public latitude: number,
    public longitude: number,
    public displayName: string
  ) { }
}

export interface RequestEvent {
  startDate?: Date;
  endDate?: Date;
  eventType?: string;
  eventLocation?: string;
  eventAvailable?: boolean;
  eventEntity?: Entity;
}

export interface Event {
  _entityName?: string;
  _eventHours?: string;
  _reservationsLeft?: number;
  _reservationsString?: string;
  _htmlPhotoUrl?: string;
  _safeHtmlProgressBar?: SafeHtml;
  _startDate?: Date;
  _startDateHour?: Date;
  _endDate?: Date;

  id?: number;
  category?: string;
  name?: string;
  shortDescription?: string;
  longDescription?: string;
  locationDescription?: string;
  locationLat?: number;
  locationLng?: number;
  photoUrl?: string;
  dateStart?: Date;
  dateEnd?: Date;
  entityId?: number;
  totalSlots?: number;
  reservedSlots?: number;
}

export interface EventReservation {
  id?: number;
  event?: Event;
  user?: UserProfile;
  eventId?: number;
  userUid?: string;
  creationDate?: Date;
}

export interface Entity {
  _iconClassLockUnlock?: string;
  _canBeDeleted?: boolean;
  _canBeRestored?: boolean;

  id?: number;
  name?: string;
  disable?: boolean;
  hasAssociatedEvents?: boolean;
}

export interface UserProfile {
  uid?: string;
  email?: string;
  psw?: string;
  name?: string;
  surname?: string;
  phone?: string;
  dateOfBirth?: Date;
  job?: string;
  education?: string;
  canEditEntities?: boolean;
  canEditEvents?: boolean;
  canEditManifestations?: boolean;
  isAcceptedPrivacy?: boolean;
}

export interface SubscriberView {
  _flgTerminated?: boolean;

  id?: number;
  name?: string;
  surname?: string;
  email?: string;
  phone?: string;
  eventCategory?: string;
  eventTitle?: string;
  eventDateStart?: Date;
  eventDateEnd?: Date;
  eventId?: number;
}
